import { blue } from '../colors';
export const secondaryColor = (mode)=>{
    return mode === 'light' ? {
        main: blue[600],
        highContrast: blue[800],
        lowContrast: blue[150]
    } : {
        main: blue[500],
        highContrast: blue[300],
        lowContrast: blue[700]
    };
};

//# sourceMappingURL=secondary.js.map